// extracted by mini-css-extract-plugin
export default {"formGroup":"EmailTemplateForm_formGroup__J5MGJ","actions":"EmailTemplateForm_actions__5AqhB"};